import { render } from "./RewardsManager.vue?vue&type=template&id=063c6270&scoped=true&ts=true"
import script from "./RewardsManager.vue?vue&type=script&lang=ts"
export * from "./RewardsManager.vue?vue&type=script&lang=ts"

import "./RewardsManager.vue?vue&type=style&index=0&id=063c6270&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063c6270"]])

export default __exports__